import React from "react";

import Label from "@busbud/design-system-components/dist/Label/Label";

import { useAppContext } from "@app/helpers/hooks";
import type { NapiV2Ticket } from "@app/types/napi-v2-tickets-types";

import { getTranslatedPassengerCategory } from "../../../../helpers/translations";

interface PassengerTicketProps {
  ticket: NapiV2Ticket;
}

export const PassengerTicketLabel: React.FC<PassengerTicketProps> = ({
  ticket
}) => {
  const { translator } = useAppContext();
  const { first_name, last_name, category } = ticket.passenger;
  const full_name = `${first_name} ${last_name}`;
  const translated_category = getTranslatedPassengerCategory(
    category,
    translator
  );
  return (
    <Label size="lg" fontWeight="bold">
      {`${full_name} — ${translated_category}`}
    </Label>
  );
};
